import React, { useState, useEffect, useRef } from "react"
import { useHistory, withRouter } from "react-router-dom"
import {
  Button,
  Col,
  Container,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import { FaFile } from "react-icons/fa6"

import { FaCloudDownloadAlt } from "react-icons/fa"
import { LuHardDriveDownload } from "react-icons/lu"
import { IoCloudDownloadOutline } from "react-icons/io5"

//Import Component
import Breadcrumbs from "components/Common/Breadcrumb"
import PaginationComponent from "common/PaginationComponent"

import { convertPermission } from "permissionUtils"
import UnAuthorizedComponent from "common/UnAuthorizedComponent"

import { usePrevious } from "common/CustomHooks"
import FilterTawuniyaProjectsData from "./FilterTawuniyaProjectsData"
import AddProjectData from "./AddProjectData"
import axios from "axios"
import InsertedDataResult from "./InsertedDataResult"
import ClientContactInfo from "./ClientContactInfo"

const TawuniyaProjectsData = () => {
  const [loading, setLoading] = useState(true)
  const [editing, setEditing] = useState(false)
  const [insertedDataResult, setInsertedDataResult] = useState()
  const [insertedDataResultType, setInsertedDataResultType] = useState()

  //meta title
  // document.title =
  // "Tawuniya Projects Data | DomApp - React Admin & Dashboard Template"

  const history = useHistory()

  const userid = localStorage.getItem("id")
  const role = localStorage.getItem("role")

  const [projectsList, setProjectsList] = useState([{}])

  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )
  // console.log("userPermissions", userPermissions)

  // **************** Authorization ******************************
  const [auth, setAuth] = useState(false)

  // **********pagination *********************
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  //******************* Filter Section ********************//
  const [categories, setCategories] = useState([])
  const [stages, setStages] = useState([])

  const [sorting, setSorting] = useState("")

  const initialFilteredValues = {
    policyNo: [],
    surveyNo: [],
    uploadStatus: [],
    startDate: "",
    endDate: "",
    uploadStartDate: "",
    uploadEndDate: "",
  }
  const [filteredValues, setFilteredValues] = useState(initialFilteredValues)

  console.log("filteredValues", filteredValues)

  // ************************************************************ //

  const prevFilteredValues = usePrevious(filteredValues)

  const formData = {
    PerToken: localStorage.getItem("token"),
    PerUserID: localStorage.getItem("id"),
    PerRoleID: localStorage.getItem("userRoleID"),
    Page: page,
    PolicyNo: filteredValues.policyNo.join(","),
    ArealDecisionNumber: filteredValues.surveyNo.join(","),
    Status: filteredValues.uploadStatus.map(item => item.value).join(","),
    StartDate: filteredValues.startDate,
    EndDate: filteredValues.endDate || filteredValues.startDate,
    UPStartDate: filteredValues.uploadStartDate,
    UPEndDate: filteredValues.uploadEndDate || filteredValues.uploadStartDate,
  }

  useEffect(() => {
    // setLoading(true)
    // setProjectListData([])

    const controller = new AbortController()
    const signal = controller.signal

    if (JSON.stringify(prevFilteredValues) !== JSON.stringify(filteredValues)) {
      setPage(1)
    }

    if (sorting === "ADD-DESC") {
      formData.ADD = "DESC"
    } else if (sorting === "ADD-ASC") {
      formData.ADD = "ASC"
    } else if (sorting === "UP-DESC") {
      formData.UP = "DESC"
    } else if (sorting === "UP-ASC") {
      formData.UP = "ASC"
    }

    axios
      .post(
        process.env.REACT_APP_API_URL + "api/amanat/AmanaList.php",
        formData,
        {
          signal,
        }
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
          setLoading(false)
          return
        }
        // if (res.data.error === true) {
        //   setLoading(false)
        //   setProjectListData([])
        //   return
        // }

        console.log("res.data", res.data)
        setTotalPages(res.data.TotalPages)
        let array = Object.values(res.data)
        console.log("array", array)
        array.splice(-4)
        setProjectsList(array)
      })
      .catch(error => {
        if (error.name === "CanceledError") {
          console.log("Request canceled")
        } else {
          console.log(error)
          setLoading(false)
        }
      })

    return () => {
      controller.abort()
    }
  }, [page, filteredValues, sorting, editing])

  // *************************** Client Contact Info ********************************* //
  const [selectedItem, setSelectedItem] = useState()
  const [clientContactModal, setClientContactModal] = useState(false)
  const clientContactToggle = () => {
    setClientContactModal(clientContactModal => !clientContactModal)
  }

  // *************************** Add Data ********************************* //
  const [addModal, setAddModal] = useState(false)
  const addToggle = () => {
    setAddModal(addModal => !addModal)
  }

  // *************************** Inserted Data Result ********************************* //
  const [insertedDataResultModal, setInsertedDataResultModal] = useState(false)
  const insertedDataResultToggle = () => {
    setInsertedDataResultModal(
      insertedDataResultModal => !insertedDataResultModal
    )
  }

  //   const exportHandler = async () => {
  //     // const formData = {}
  //     // const filename = `tawuniya-${Date.now()}`
  //     // try {
  //     //   const response = await axios.post(
  //     //     `${process.env.REACT_APP_API_URL}api/amanat/Export.php`,
  //     //     formData,
  //     //     {
  //     //       headers: {
  //     //         "Content-Type": "application/json",
  //     //       },
  //     //       responseType: "blob", // Important for file download
  //     //     }
  //     //   )

  //     //   const blob = new Blob([response.data])
  //     //   const downloadUrl = window.URL.createObjectURL(blob)
  //     //   const link = document.createElement("a")

  //     //   link.href = downloadUrl

  //     //   //   Try to get filename from Content-Disposition header
  //     //   const contentDisposition = response.headers["content-disposition"]
  //     //   console.log("contentDisposition", contentDisposition)
  //     //   if (contentDisposition && contentDisposition.includes("filename=")) {
  //     //     const extractedFilename = contentDisposition
  //     //       .split("filename=")[1]
  //     //       .replace(/['"]/g, "")
  //     //     filename = extractedFilename
  //     //   }

  //     //   link.download = filename
  //     //   document.body.appendChild(link)
  //     //   link.click()
  //     //   document.body.removeChild(link)
  //     //   window.URL.revokeObjectURL(downloadUrl)
  //     // } catch (error) {
  //     //   console.error("File download failed", error)
  //     // }

  //   }

  const exportHandler = async dataObj => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}api/amanat/Export.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataObj),
        }
      )

      if (!response.ok) throw new Error("Network response was not ok")

      // Get filename from headers or use default
      const disposition = response.headers.get("Content-Disposition")
      const match = disposition && disposition.match(/filename="?([^"]+)"?/)
      const filename = match ? match[1] : `AMANAT_${Date.now()}`

      // Convert response to Blob and trigger download
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement("a")
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()

      // Clean up
      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
    } catch (error) {
      console.error("Download failed:", error)
      alert("Download failed. Check the server response.")
    }
  }

  const downloadDataHandler = file => {
    window.open(file, "_blank", "noopener,noreferrer")
  }

  // Access denied !!
  if (auth) {
    return <UnAuthorizedComponent />
  }

  // not allowed views
  if (
    userPermissions.R34.P !== "1" &&
    userPermissions.R34.P !== "2" &&
    userPermissions.R34.P !== "3" &&
    userPermissions.R34.P !== "4" &&
    userPermissions.R34.G !== "1"
  ) {
    return (
      <div className="page-content">
        <h3 className="d-flex justify-content-center p-3 text-light bg-danger">
          You are not authenticated!!
        </h3>
      </div>
    )
  } else {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs
              title="Projects"
              breadcrumbItem="Tawuniya Projects Data"
            />

            <Row>
              <Col lg="12">
                <FilterTawuniyaProjectsData
                  filteredValues={filteredValues}
                  setFilteredValues={setFilteredValues}
                  setAuth={setAuth}
                  userPermissions={userPermissions}
                />
                <div className="d-flex justify-content-end align-items-center">
                  {(userPermissions.R34.P === "3" ||
                    userPermissions.R34.P === "4" ||
                    userPermissions.R34.G === "1") && (
                    <Button className="mx-1" onClick={addToggle}>
                      Add
                    </Button>
                  )}

                  {(userPermissions.R34.P === "2" ||
                    userPermissions.R34.P === "3" ||
                    userPermissions.R34.P === "4" ||
                    userPermissions.R34.G === "1") && (
                    <Button
                      className="mx-1"
                      onClick={() => exportHandler(formData)}
                    >
                      Export
                    </Button>
                  )}
                </div>

                {/******************* table section**************************/}
                <Table className="project-list-table table-nowrap align-middle table-borderless my-table">
                  <thead>
                    <tr style={{ backgroundColor: "rgb(230, 239, 252)" }}>
                      <th scope="col" style={{ width: "20px" }}>
                        ID
                      </th>
                      <th scope="col">Policy No</th>
                      <th scope="col">Survey No</th>
                      <th scope="col">Upload Status</th>

                      <th
                        scope="col"
                        style={{ cursor: "pointer", position: "relative" }}
                        onClick={e => {
                          // e.preventDefault()
                          if (sorting !== "ADD-DESC") {
                            setSorting("ADD-DESC")
                          } else {
                            setSorting("ADD-ASC")
                          }
                        }}
                      >
                        <span className="mx-1">Adding Date</span>
                        {sorting === "ADD-ASC" ? (
                          <i className="mdi mdi-arrow-down-bold" />
                        ) : sorting === "ADD-DESC" ? (
                          <i className="mdi mdi-arrow-up-bold" />
                        ) : (
                          <i className="mdi mdi-arrow-up-down-bold" />
                        )}
                      </th>

                      <th
                        scope="col"
                        style={{ cursor: "pointer", position: "relative" }}
                        onClick={e => {
                          // e.preventDefault()
                          if (sorting !== "UP-DESC") {
                            setSorting("UP-DESC")
                          } else {
                            setSorting("UP-ASC")
                          }
                        }}
                      >
                        <span className="mx-1">Upload Date</span>
                        {sorting === "UP-ASC" ? (
                          <i className="mdi mdi-arrow-down-bold" />
                        ) : sorting === "UP-DESC" ? (
                          <i className="mdi mdi-arrow-up-bold" />
                        ) : (
                          <i className="mdi mdi-arrow-up-down-bold" />
                        )}
                      </th>

                      {(userPermissions.R34.P === "2" ||
                        userPermissions.R34.P === "3" ||
                        userPermissions.R34.P === "4" ||
                        userPermissions.R34.G === "1") && (
                        <th scope="col">Action</th>
                      )}
                    </tr>
                  </thead>
                  {/***********table body *****************/}
                  <tbody>
                    {[...projectsList].reverse().map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item.id}</td>

                          <td>{item.PolicyNo}</td>

                          <td>{item.ArealDecisionNumber}</td>

                          <td>
                            <span
                              className={
                                item.Status === "Waiting"
                                  ? "badge bg-warning"
                                  : item.Status === "Uploaded"
                                  ? "badge bg-success"
                                  : ""
                              }
                            >
                              {item.Status}
                            </span>
                          </td>

                          <td>{item.CreatedAt}</td>

                          <td>{item.AnswerAt}</td>

                          {(userPermissions.R34.P === "2" ||
                            userPermissions.R34.P === "3" ||
                            userPermissions.R34.P === "4" ||
                            userPermissions.R34.G === "1") && (
                            <td>
                              <button
                                style={{
                                  border: "none",
                                  backgroundColor: "transparent",
                                  fontSize: "24px",
                                }}
                                onClick={() => {
                                  setSelectedItem(item)
                                  clientContactToggle()
                                }}
                                disabled={!item.AddCName && !item.AddUName}
                              >
                                <span
                                  className="mdi mdi-account-details"
                                  id={`clientContact-${item.id}`}
                                ></span>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`clientContact-${item.id}`}
                                >
                                  Client Contact
                                </UncontrolledTooltip>
                              </button>

                              <button
                                style={{
                                  border: "none",
                                  backgroundColor: "transparent",
                                  fontSize: "24px",
                                }}
                                onClick={() => downloadDataHandler(item.IDI)}
                                disabled={!item.IDI}
                              >
                                <FaFile id={`IDI-${item.id}`} />
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`IDI-${item.id}`}
                                >
                                  IDI
                                </UncontrolledTooltip>
                              </button>

                              <button
                                style={{
                                  border: "none",
                                  backgroundColor: "transparent",
                                  fontSize: "24px",
                                }}
                                onClick={() => downloadDataHandler(item.Link)}
                                disabled={item.Status !== "Uploaded"}
                              >
                                <FaCloudDownloadAlt id={`link-${item.id}`} />
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`link-${item.id}`}
                                >
                                  RAR
                                </UncontrolledTooltip>
                              </button>
                            </td>
                          )}
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>

            {/* ********************** Client Contact Info ********************************* */}
            {clientContactModal && (
              <ClientContactInfo
                clientContactToggle={clientContactToggle}
                selectedItem={selectedItem}
              />
            )}

            {/* ********************** Add Project Data ********************************* */}
            {addModal && (
              <AddProjectData
                addToggle={addToggle}
                setAuth={setAuth}
                setInsertedDataResult={setInsertedDataResult}
                setInsertedDataResultType={setInsertedDataResultType}
                insertedDataResultToggle={insertedDataResultToggle}
              />
            )}

            {/* ********************** Inserted Data Result ********************************* */}
            {insertedDataResultModal && (
              <InsertedDataResult
                insertedDataResultToggle={insertedDataResultToggle}
                insertedDataResult={insertedDataResult}
                setInsertedDataResult={setInsertedDataResult}
                insertedDataResultType={insertedDataResultType}
                setInsertedDataResultType={setInsertedDataResultType}
              />
            )}

            {/* ********************** Pagination ********************************* */}
            {projectsList.length > 1 && (
              <Row>
                <PaginationComponent
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  setTotalPages={setTotalPages}
                />
              </Row>
            )}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default withRouter(TawuniyaProjectsData)
